<h3-read-only-workspace-navbar
  [submissions]="submissions"
  [stepId]="stepId"
></h3-read-only-workspace-navbar>

@if ((modelsLoading$ | async) === 'loaded') {
  @if (isUsingGenAi$ | async) {
    <h3-gen-ai-container></h3-gen-ai-container>
  } @else if (isUsingCategorization$ | async) {
    <h3-categorization-container></h3-categorization-container>
  } @else {
    <div class="workspace-outline">
      <h3-root-h3ml-container></h3-root-h3ml-container>
    </div>
  }
}
